import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=af097a34&scoped=true"
import script from "./MyPage.vue?vue&type=script&lang=ts"
export * from "./MyPage.vue?vue&type=script&lang=ts"
import style0 from "./MyPage.vue?vue&type=style&index=0&id=af097a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af097a34",
  null
  
)

export default component.exports